import { render, staticRenderFns } from "./dateItem.vue?vue&type=template&id=24e4e9c6"
import script from "./dateItem.vue?vue&type=script&lang=js"
export * from "./dateItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports